import { Wrapper as InputComponent } from "../Core/styles";

import styled from "styled-components";

export const Wrapper = styled.div`
  ${InputComponent} {
    display: none;
  }
`;

export const Input = styled.input`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px;

  width: 48px;
  height: 56px;

  background: ${({ theme }) => theme.colors.neutral.white};
  border: 1px solid ${({ theme }) => theme.colors.neutral.gray4};
  border-radius: 8px;
  padding: 16px 18px;

  flex: none;
  order: 0;
  flex-grow: 0;

  font-family: ${({ theme }) => theme.font.fontFamily};
  font-size: 20px;
  font-weight: 300;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;

  color: ${({ theme }) => theme.colors.primary.cetaceanBlue};

  &::placeholder {
    color: ${({ theme }) => theme.colors.neutral.gray4};
  }

  &:focus {
    border: none;
    outline: 1.5px solid ${({ theme }) => theme.colors.feedbackState.info.hover};
  }
`;

export const InputWrapper = styled.div`
  grid-area: ${({ gridArea }) => gridArea};
  margin-left: ${({ margin }) => margin}px;

  display: grid;
  grid-template-columns: repeat(${({ digits }) => digits}, 48px);
  grid-gap: 8px;
`;
